import {Button, Collapse, Grid, Link} from "@mui/material";
import {useEffect, useState} from "react";
import {Box} from "@mui/system";
import {useNavigate} from "react-router-dom";
import {usePapaParse} from "react-papaparse";

import classes from "../Style/ChapterOne.scss";
import PageRoutes from "../Config/PageRoutes";
import neg1 from "../Assets/neg1.png";

//components
import Findings from "../Components/ChapterOne/Findings";
import GroupBulletChart from "../Components/Charts/GroupBulletChart";
import ModalTrigger from "../Components/Common/ModalTrigger";
import CircleSvg from "./../Components/CircleSvg";
import DottedCircleSvg from "./../Components/DottedCircleSvg";

import FilteredDataGrid from "./../Components/ChapterTwo/FilteredDataGrid";

//charts
import HorizontalBarChart from "../Components/Charts/HorizontalBarChart";
import HeatMapChart from "../Components/Charts/HeatMapChart";
import TableGrid from "../Components/ChapterOne/TableGrid";

// csv
import csv4 from "../Data/MANCP/Pesticides/MANCP-Results-on-import-control-samples-under-Regulation-2019-1793.csv";

//maps
import FirstRow from "../Components/ChapterThree/rows/FirstRow";

const ChapterThree = () => {
  const navigate = useNavigate();

  const [expanded, setExpanded] = useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const goToChapterTwo = () => {
    navigate("../" + PageRoutes.CHAPTER_TWO);
  };

  return (
    <Grid container direction="column" className="wrapper-one">
      <Grid container direction="column" className="chapterOneWrapper">
        {/* First row */ }
        <FirstRow/>
        {/* First row */ }

        {/* Second row */ }
        <Grid
          item
          container
          direction={ {xs: "column", sm: "column", md: "row"} }
          sx={ {
            marginTop: {xs: "50px", sm: "50px", md: "30px"},
            alignItems: {sm: "center", md: "center"},
            width: "100%",
          } }
          className="two-one-wrapper"
        >
          <div className="circle-svg">
            <CircleSvg/>
          </div>
          <Grid
            item
            xs
            p={ 3 }
            className="two-one"
            sx={ {maxWidth: {md: "450px !important"}} }
          >
          </Grid>
        </Grid>
        {/* Second row */ }
        {/* Third row */ }

        {/* Third row */ }

        {/* Fourth row */ }

        {/* Fourth row */ }

        {/* Fifth row */ }

        {/* Fifth row */ }
        {/* Sixth row */ }

        <Grid
          item
          container
          direction={ {xs: "column", sm: "column", md: "row"} }
          sx={ {
            marginTop: {xs: "50px", sm: "50px", md: "90px"},
            marginBottom: {xs: "50px", sm: "50px", md: "90px"},
          } }
        >
          <Grid
            item
            xs
            p={ 3 }
            className="five-two"
            sx={ {maxWidth: "100% !important"} }
          >
            <FilteredDataGrid csv={ csv4 }/>
          </Grid>
        </Grid>
        {/* Seventh row */ }

        {/* Eighth row , footer*/ }

        <Grid
          item
          container
          direction="column"
          alignContent="center"
          className="footerWrapper"
        >
          <div className="dottedCircle">
            <DottedCircleSvg/>
          </div>
          <Grid item xs className="footer">
            <Box className="nine-one-inner" sx={ {display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center"} }>
              <p>
                <b>Read more about the 2024 results</b>
              </p>
              <Button
                className="footerButton"
                variant="outlined"
                component={ Link }
                target="_blank"
                href="https://efsa.onlinelibrary.wiley.com/doi/full/10.2903/j.efsa.2026.10054"
                rel="noreferrer"
              >
                SCIENTIFIC REPORT
              </Button>
            </Box>
          </Grid>
        </Grid>
        {/* Eighth row */ }
      </Grid>
    </Grid>
  );
};

export default ChapterThree;

